import { Props } from 'react-select';

export interface ISelectCarmaProps extends Props<ISelectCarmaOption> {
  options: ISelectCarmaOption[];
  value?: ISelectCarmaOption | undefined;
}

export interface ISelectCarmaOption {
  id: number;
  label: string;
  value: number;
  score?: number;
  type?: ISelectCarmaOptionType;
  icon?: React.ReactNode;
  onClick?: () => void;
}

export enum ISelectCarmaOptionType {
  Button = 'button',
}